import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
import { colors } from "vuetify/lib";

Vue.use(Vuetify);

const opts = {
  iconfont: "mdi",
  theme: {
    dark: true,
    themes: {
      light: {
        primary: "#fdc300",
        accent: colors.yellow.accent3,
        success: colors.green,
        info: colors.yellow.accent3,
        error: colors.red.accent1,
        background: colors.amber.accent1
      },
      dark: {
        primary: "#fdc300",
        accent: colors.yellow.accent3,
        success: colors.green,
        info: colors.yellow.accent3,
        error: colors.red.accent1
      }
    }
  }
};

export default new Vuetify(opts);
